// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1sT61","badges":"styles_badges__2ZNAC"};